<template>
<!-- eslint-disable -->
  <div>
      <BaseControlBar>
        <h1>常見問題</h1>
      </BaseControlBar>
      <FAQText></FAQText>
  </div>
</template>

<script>
import BaseControlBar from '@/components/BaseControlBar.vue';
import FAQText from '@/views/static/content/FAQText.vue';

export default {
  components: {
    BaseControlBar,
    FAQText,
  },
};
</script>

<style scoped>

</style>
